import styles from './FoundationNameWithFlag.module.scss'
import { FoundationNameWithFlagProps } from './FoundationNameWithFlag.types'
import { FlagAvatar } from '@percent/lemonade'

// A span, not a div: this renders inside Lemonade's Filter trigger `<button>` among other places,
// which takes only phrasing content. The wrapper is already inline-flex, so nothing moves.
export function FoundationNameWithFlag({ countryCode, name }: FoundationNameWithFlagProps) {
  return (
    <span className={styles.wrapper}>
      <FlagAvatar code3={countryCode} />
      <span>{name}</span>
    </span>
  )
}
